module.exports = __webpack_public_path__ + "static/media/running.ec9451d3.svg";